import { IconCheck } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface Props {
  isApplied: boolean;
  disabled?: boolean;
  className?: string;
}

export default function ApplyButton({ isApplied, disabled, className }: Props) {
  return (
    <div className={cn("flex w-24 shrink-0 items-center justify-center", className)}>
      {isApplied ? (
        <span className="flex items-center gap-1 text-sm text-green-600">
          <IconCheck size={16} />
          Applied
        </span>
      ) : (
        <Button type="submit" size="default" className="w-full" disabled={disabled}>
          Apply
        </Button>
      )}
    </div>
  );
}
